import { body } from "../lib/instructions_lib";

const Instructions = (): JSX.Element => <p>{body}</p>;

export default Instructions;
